import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "disabled", "isLocked", "tooltip"];
import { ButtonIconBreeze } from 'breeze-intelligence-kit';
import { ButtonIconBreezeTooltip } from 'breeze-intelligence-kit';
import { LockBadge } from 'breeze-intelligence-kit';
import { CreditUpgradeTooltip } from '../ModalBulk/CreditUpgradeTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EnrichmentActionButton(_ref) {
  let {
      children,
      disabled,
      isLocked,
      tooltip = /*#__PURE__*/_jsx(CreditUpgradeTooltip, {})
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isDisabled = disabled || isLocked;
  if (isLocked) {
    return /*#__PURE__*/_jsxs(ButtonIconBreezeTooltip, Object.assign({}, rest, {
      disabled: true,
      tooltip: tooltip,
      width: 300,
      children: [children, /*#__PURE__*/_jsx(LockBadge, {})]
    }));
  }
  return /*#__PURE__*/_jsx(ButtonIconBreeze, Object.assign({}, rest, {
    disabled: isDisabled,
    children: children
  }));
}